import { ReactNode, useContext, useState } from "react";
import React from "react";
import { DropdownProps } from "semantic-ui-react";
import { StatePackage } from "../State";
import { Action, arrayProjector, store } from "../store";
import QuestionAnswer from "../answers/QuestionAnswer";

// tslint:disable-next-line: interface-name
interface SwitcherState {
    option: any;
}

// tslint:disable-next-line: interface-name
interface Props {
    source: any[];
    answerContent: string;
    questionContent: string;
    action: Action;
    arrayProjector: arrayProjector[];
    content: ReactNode[];
    defaultValue: any;
    index: number;
}

// tslint:disable-next-line: max-line-length
function handleSwitch(index: number, d: DropdownProps, dispatch: React.Dispatch<Action>, action: Action, source: any[], projector: arrayProjector[], s2: StatePackage<SwitcherState>): void {
    s2.setState({ ...s2.state, option: d.value });
    const map = projector[parseInt(d.value as string, 10)](source);
    dispatch({ ...action, value: map, index: index });
}

const ComponentSwitcher: React.FunctionComponent<Props> = (props: Props) => {
    const [state, setState] = useState<SwitcherState>({ option: props.defaultValue });
    const globalState = useContext(store);
    const { dispatch } = globalState;

    return (
        <div>
            <QuestionAnswer index={props.index}
                            propsBase={{ answerContent: props.answerContent,
                                answerType: "DropDown", answerValidator: (s) => s.length > 0,
                                isRequired: true, questionContent: props.questionContent, answerValue: state.option, isAnswerValid: false,
                                isAnswered: state.option.length > 0, showError: false, propName: "N/A"
                }}
                // tslint:disable-next-line: max-line-length
                onChange={(e, i, d) => handleSwitch(props.index, d as DropdownProps, dispatch, props.action, props.source, props.arrayProjector, { setState, state })}
            />
            {
                parseInt(state.option, 10) != null && props.content[parseInt(state.option, 10)]
            }
      </div>
    );
  };

export default ComponentSwitcher;
